@if (!loading) {
<div class="commandes-edit-container">
  <h2>Modifier la commande</h2>
  <label for="commande_select">Choisir une commande</label>
  <select id="commande_select" [ngModel]="commandeId" (ngModelChange)="selectCommande($event)">
      <option [ngValue]="0">-- Sélectionnez une commande --</option>
      @for (c of commandesList; track c.id) {
        <option [ngValue]="c.id">#{{c.id}} - {{c.numero_commande}}</option>
      }
  </select>
    @if (success) {
      <div class="success">{{ success }}</div>
    }
    @if (error) {
      <div class="error">{{ error }}</div>
    }
    @if (commandeId) {
      <form (ngSubmit)="save()" #form="ngForm">
        <label for="numero_commande">Numéro de commande faite par le client à Veolia</label>
        <input matInput [(ngModel)]="commande.numero_commande" name="numero_commande" id="numero_commande" required>
        <label for="statut">Statut</label>
        <select [(ngModel)]="commande.statut" name="statut" id="statut" required>
          @for (s of statutsCommande; track s.value) {
            <option [value]="s.value">{{ s.label }}</option>
          }
        </select>
        <label for="client_id">Client *</label>
        <select id="client_id" name="client_id" [(ngModel)]="commande.client_id" required>
          <option value="">-- sélectionner --</option>
          @for (client of clients; track client.id) {
            <option [value]="client.id">{{ client.identifiant }}</option>
          }
        </select>
        <label for="nombre_capteurs">Nombre de capteurs</label>
        <div class="nombre-capteurs-row">
          <input
            matInput
            [(ngModel)]="commande.nombre_capteurs"
            name="nombre_capteurs"
            id="nombre_capteurs"
            type="number"
            min="0"
          >
          <span class="ligne-count-text">Nombre de lignes de commande : {{ lignesCommande.length }}</span>
        </div>
        <button  color="primary" type="submit" [disabled]="saving || form.invalid">Enregistrer</button>
        <button  type="button" routerLink="/commandes">Annuler</button>
      </form>

      <section class="panel" style="margin-top:2rem">
        <h3>Lignes de commande</h3>
        @if (ligneSuccess) {
          <div class="success">{{ ligneSuccess }}</div>
        }
        <form (ngSubmit)="addLigne()" #ligneForm="ngForm" class="ligne-form">
          <label for="type_capteur">Type capteur</label>
          <select [(ngModel)]="nouvelleLigne.type_capteur" (ngModelChange)="onNouvelleLigneTypeCapteurChange()" name="type_capteur" id="type_capteur">
            @for (t of typeCapteurs; track t.id) {
              <option [value]="t.nom">{{ t.nom }}</option>
            }
          </select>
          <label for="adresse_livraison_id">Adresse livraison</label>
          <select [(ngModel)]="nouvelleLigne.adresse_livraison_id" name="adresse_livraison_id" id="adresse_livraison_id">
            <option value="">-- sélectionner --</option>
            @for (adresse of adressesLivraisonClient; track adresse.id) {
              <option [value]="adresse.id">{{ adresse.adresse }} {{ adresse.code_postal }} {{ adresse.ville }}</option>
            }
          </select>
          <label for="cartoucheAInput">{{ getFirstCartoucheLabel(nouvelleLigne.type_capteur) }}</label>
          <input matInput [matAutocomplete]="autoA" [(ngModel)]="cartoucheAInput" (ngModelChange)="searchCartoucheA($event)" (focus)="searchCartoucheA(cartoucheAInput)" (keyup)="onCartoucheKeypress()" name="cartoucheAInput" id="cartoucheAInput" autocomplete="off">
          <mat-autocomplete #autoA="matAutocomplete" (optionSelected)="onCartoucheASelected($event)">
            @for (c of cartoucheAOptions; track c.id) {
              <mat-option [value]="c.nom">{{ getCartoucheOptionLabel(c) }}</mat-option>
            }
          </mat-autocomplete>
          @if (!isSingleCartoucheType(nouvelleLigne.type_capteur)) {
            <label for="cartoucheBInput">Deuxième cartouche</label>
            <input matInput [matAutocomplete]="autoB" [(ngModel)]="cartoucheBInput" (ngModelChange)="searchCartoucheB($event)" (focus)="searchCartoucheB(cartoucheBInput)" (keyup)="onCartoucheKeypress()" name="cartoucheBInput" id="cartoucheBInput" autocomplete="off">
            <mat-autocomplete #autoB="matAutocomplete" (optionSelected)="onCartoucheBSelected($event)">
              @for (c of cartoucheBOptions; track c.id) {
                <mat-option [value]="c.nom">{{ getCartoucheOptionLabel(c) }}</mat-option>
              }
            </mat-autocomplete>
          }
          <label for="date_expedition">Date expédition souhaitée</label>
          <!-- ...reste du formulaire... -->
    
          <input matInput type="date" [(ngModel)]="nouvelleLigne.date_expedition" name="date_expedition" id="date_expedition">

          <button  color="primary" type="submit">Ajouter</button>
      </form>
    </section>
  }
  @if (commandeId) {
    <div class="table-responsive">
      <table class="table-wrap" style="width:100%;margin-top:1rem">
        <thead>
          <tr>
            <th>ID</th>
            <th>Type capteur</th>
            <th>Adresse livraison</th>
            <th>Première cartouche</th>
            <th>Deuxième cartouche</th>
            <th>Date expédition souhaitée</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (ligne of lignesCommande; track ligne.id) {
          <tr>
            <td>{{ ligne.id }}</td>
            <td>
              @if (isEditingLigne(ligne)) {
                <select [(ngModel)]="ligne.type_capteur" (ngModelChange)="onLigneTypeCapteurChange(ligne)" name="type_capteur_{{ligne.id}}">
                  @for (t of typeCapteurs; track t.id) {
                    <option [value]="t.nom">{{ t.nom }}</option>
                  }
                </select>
              } @else {
                <span>{{ ligne.type_capteur || '-' }}</span>
              }
            </td>
            <td>
              @if (isEditingLigne(ligne)) {
                <select [(ngModel)]="ligne.adresse_livraison_id" name="adresse_livraison_id_{{ligne.id}}" style="width:180px">
                  <option value="">-- sélectionner --</option>
                  @for (adresse of adressesLivraisonClient; track adresse.id) {
                    <option [value]="adresse.id">{{ adresse.adresse }} {{ adresse.code_postal }} {{ adresse.ville }}</option>
                  }
                </select>
              } @else {
                <span>{{ getAdresseLivraisonLabel(ligne.adresse_livraison_id) || '-' }}</span>
              }
            </td>
            <td>
              @if (isEditingLigne(ligne)) {
                <input matInput [matAutocomplete]="autoA" [(ngModel)]="ligne.cartoucheAInput" (ngModelChange)="onCartoucheAInputChange($event, ligne)" (focus)="onCartoucheAInputChange(ligne.cartoucheAInput ?? '', ligne)" (keyup)="onCartoucheKeypress()" name="cartoucheAInput_{{ligne.id}}" autocomplete="off">
                <mat-autocomplete #autoA="matAutocomplete" (optionSelected)="ligne.cartoucheAInput = $event.option.value; ligne.cartouche_a = cartoucheAOptions.find(c => c.nom === $event.option.value)?.id">
                  @for (c of cartoucheAOptions; track c.id) {
                    <mat-option [value]="c.nom">{{ c.nom }}</mat-option>
                  }
                </mat-autocomplete>
              } @else {
                <span>{{ ligne.cartoucheAInput || '-' }}</span>
              }
            </td>
            <td>
              @if (isSingleCartoucheType(ligne.type_capteur)) {
                <span>-</span>
              } @else {
                @if (isEditingLigne(ligne)) {
                  <input matInput [matAutocomplete]="autoB" [(ngModel)]="ligne.cartoucheBInput" (ngModelChange)="onCartoucheBInputChange($event, ligne)" (focus)="onCartoucheBInputChange(ligne.cartoucheBInput ?? '', ligne)" (keyup)="onCartoucheKeypress()" name="cartoucheBInput_{{ligne.id}}" autocomplete="off">
                  <mat-autocomplete #autoB="matAutocomplete" (optionSelected)="ligne.cartoucheBInput = $event.option.value; ligne.cartouche_b = cartoucheBOptions.find(c => c.nom === $event.option.value)?.id">
                    @for (c of cartoucheBOptions; track c.id) {
                      <mat-option [value]="c.nom">{{ c.nom }}</mat-option>
                    }
                  </mat-autocomplete>
                } @else {
                  <span>{{ ligne.cartoucheBInput || '-' }}</span>
                }
              }
            </td>
            <td>
              @if (isEditingLigne(ligne)) {
                <input [(ngModel)]="ligne.date_expedition" name="date_expedition_{{ligne.id}}" type="date" style="width:130px">
              } @else {
                <span>{{ formatDateFr(ligne.date_expedition) }}</span>
              }
            </td>
            <td>
              <span>{{ getStatutLabel(ligne) }}</span>
            </td>
            <td>
              @if (isEditingLigne(ligne)) {
                <button type="button" color="primary" (click)="updateLigne(ligne)">Enregistrer</button>
              } @else if (isLigneEditable(ligne)) {
                <button type="button" color="primary" (click)="startEditLigne(ligne)">Modifier</button>
                <button type="button" color="accent" (click)="transferLigne(ligne)">Transférer</button>
              } 
              <button type="button" color="warn" (click)="deleteLigne(ligne.id)">Supprimer</button>
              <button type="button" color="accent" (click)="openCapteurModale(ligne.id)">
                Voir capteur
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <app-capteur-modale
    [capteur]="capteurModaleData"
    [visible]="capteurModaleVisible"
    [onClose]="closeCapteurModale.bind(this)"
  />
  </div>

}


